import React, {useState} from 'react';
import {Link} from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
//Bootstrap hamburger menu
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

const axios = require('axios').default

const ProductsPage = () => {

    const [products, setProducts] = useState([])

    function handleSubmit (event) {
        event.preventDefault()

        axios.get(process.env.REACT_APP_SERVER_URL + "/trainer/products/" + event.target.value)
        .then((response) => {
            setProducts(response.data)
        })
        .catch((error) => {
            if (error) {
                console.log(error)
            }    
        })
    }


  return (
    <div>
    
        <Navbar collapseOnSelect expand="md" className="bg-light shadow sticky-top">
        <Container>
        
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">

                    <Link to="/trainer" className='me-2 my-auto'>
                        <ArrowBackIcon fontSize="large" className="ms-3 mt-3 text-dark"/>
                    </Link>
            
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Rice" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Rice</button>
                    </Nav.Link>
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Breads" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Breads</button>
                    </Nav.Link>
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Eggs" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Eggs</button>
                    </Nav.Link>
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Dairy" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Dairy</button>
                    </Nav.Link>
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Butter" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Butter</button>
                    </Nav.Link>
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Fruits" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Fruits</button>
                    </Nav.Link>
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Fish" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Fish</button>
                    </Nav.Link>
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Paper" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Paper</button>
                    </Nav.Link>
                    <Nav.Link href="...">
                        <button type="button" onClick={handleSubmit} value="Baking" className="btn nav-link text-dark text-decoration-underline fs-5 p-1">Baking</button>
                    </Nav.Link>
                </Nav>
        
            </Navbar.Collapse>
        </Container>
    </Navbar>


    <div className="container-fluid">
            <div className="row" style={{height: 500}}>
                {products && products.map((i) => (
                    <div className="hstack col-lg-3 col-md-4 col-sm-6" key={i._id}>
                        <div className="vstack container-fluid shadow-lg fs-5 mx-auto mt-4 mb-4" style={{borderRadius:20}} >
                            
                            {/* Aspect ratio of photo is maintained here */}
                            <div className=''>
                                <img src={__dirname + "images/"+i.image} className="container mx-auto rounded-3 mt-4" style={{maxwidth: 200}} alt=""/>
                            </div>
                            
                            <p className="text-start mb-0">{i.name}</p>
                            
                            <p className="mb-0">$ {(Number(i.price)).toFixed(2)} {i.quantifier} </p>

                            {i.expiry && <p className="text-start mb-0">Expiry: {i.expiry}</p>}
                            
                        </div>
                    </div>
                )) }
            </div>
        </div>
    </div>
  )
}

export default ProductsPage